import { BOOKABLE_STATUSES } from "./constants";
import type { AvailableTherapist, TimeSlot } from "./types";

/** "9:5" -> "09:05" (§6 slot normalization, defensive). */
export function normalizeTime(raw: string): string {
	const [h = "0", m = "0"] = raw.split(":");
	return `${h.padStart(2, "0")}:${m.padStart(2, "0")}`;
}

/** §7: positive set only (AVAILABLE / PARTIALLY_BOOKED). */
export function isBookableStatus(status: string): boolean {
	return (BOOKABLE_STATUSES as readonly string[]).includes(status);
}

/**
 * §6: a date is bookable when it has at least one real slot. No time gating —
 * admins may book any time, including today's near-term or past slots.
 */
export function hasBookableSlotForDate(slots: TimeSlot[] | null): boolean {
	return !!slots && slots.length > 0;
}

/** §9 + §7: positive status AND non-empty available_slots. */
export function filterBookableTherapists(
	therapists: AvailableTherapist[],
): AvailableTherapist[] {
	return therapists.filter(
		(t) =>
			isBookableStatus(t.availability_status) &&
			!!t.available_slots &&
			t.available_slots.length > 0,
	);
}
